import { postionsConstants } from '../../constants/position';

export type GameProviderFormKey = 'game_provider';

const gameProvidersListMap = [
	{
		label: 'Main Provider Id',
		value: 'main_provider_id',
	},
	{
		label: 'Game Provider ID',
		value: 'game_provider_id',
	},
	{
		label: 'Game Provider Name',
		value: 'game_provider_name',
	},
	{
		label: 'Active',
		value: 'active',
	},
	{
		label: 'Actions',
		value: 'actions',
		position: postionsConstants.CENTAR,
	},
	{
		label: 'Provider Url Live Desktop',
		value: 'provider_url_live_desktop',
	},
	{
		label: 'Provider Url Test Desktop',
		value: 'provider_url_test_desktop',
	},
	{
		label: 'Provider Url Live Mobile',
		value: 'provider_url_live_mobile',
	},
	{
		label: 'Provider Url Test Mobile',
		value: 'provider_url_test_mobile',
	},
	{
		label: 'History Url Live',
		value: 'history_url_live',
	},
	{
		label: 'History Url Test',
		value: 'history_url_test',
	},
];

const columnFormatter = {
	// game_provider_id: 'value',
	// game_provider_name: 'value',
	// // game_category_master: 'master',
};

const formNameMap = {
	name: 'Game provider',
};

export { gameProvidersListMap, columnFormatter, formNameMap };
